module.exports = __webpack_public_path__ + "img/lively temple grounds.98c41c2b.png";